import { C, t } from './dashboardConstants';

function SectionHeader({ title, onViewAll }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
      <span style={t('22px', 600, C.bk)}>{title}</span>
      <button onClick={onViewAll} style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px', padding: 0 }}>
        <span style={{ color: C.bk, fontFamily: 'Pretendard, sans-serif', fontSize: '16px', fontStyle: 'normal', fontWeight: 400, lineHeight: '140%', letterSpacing: '-0.64px' }}>전체 보기</span>
        <img
          src="/assets/images/here.svg"
          alt=""
          aria-hidden="true"
          style={{ width: '10.717px', height: '10.55px', display: 'block', flexShrink: 0 }}
        />
      </button>
    </div>
  );
}

export default SectionHeader;
